module.exports = ".custom-slide-text img {\n  max-height: 80px;\n  max-width: 60px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 12px; }\n"